import s from "styled-components";

export const Wrap = s.div`
  padding: 10px;
  text-align: right;
`;
export const Title = s.div`
  font-weight: 400;
  margin-bottom: 15px;
`;
export const Buttons = s.div`
  button {
    margin-bottom: 3px;
  }
  button:last-child {
    margin-left: 7px;
  }
`;
